import React from 'react';
import { SummaryGrid } from '@yuhuinc/ui-library';
import { Form } from 'ui-library';

const AssociationSummary = () => {
  const form = Form.useFormInstance();
  const associations = Form.useWatch('associations', form);

  // TODO: Improve method to count how many units were associated or get that count from backend instead
  const generateSummaryData = (associations) => [['Units associated', associations?.length || 0]];

  return <SummaryGrid values={generateSummaryData(associations)} />;
};

export default AssociationSummary;
